<template>
  <b-container>
    <b-card>
      Test
    </b-card>
  </b-container>
</template>

<script>

export default {
  name: 'social_accounts',
  props: ['user', 'site', 'profile'],
  data() {
    return {

    }
  }
}
</script>

<style scoped>

</style>
